import {useState} from 'react';
import LargeButton from '../LargeButton/LargeButton';
import ExceptionPopup from './ExceptionPopup';
import {
	raiseExceptionRequest,
	updatePartValidation,
} from '../../redux/actionCreators/partValidation';
import {connect} from 'react-redux';
import {useMessageContextManager} from '../MessageOverlay/MessageOverlay';
import {ERROR_MESSAGE} from '../../constants';
import { encryptStationPassword } from '../../utils/EncryptionUtils';

const mapStateToProps = state => {
	return {
		partValidation: state.partValidation,
	};
};

const mapDispatchToProps = dispatch => ({
	raiseExceptionRequest: (asn, payload, successCallback, errorCallback) =>
		dispatch(
			raiseExceptionRequest(asn, payload, successCallback, errorCallback),
		),
	updatePartValidation: data => dispatch(updatePartValidation(data)),
});

export const Exception = ({
	partValidation,
	raiseExceptionRequest,
	updatePartValidation,
	redirectToNextScreen,
	isExceptionAllowed,
	btnStyles = {},
}) => {
	const [openException, setExceptionPopup] = useState(false);
	const {showMessageOverlay} = useMessageContextManager();

	const addAsException = () => {
		if (isExceptionAllowed()) setExceptionPopup(true);
	};

	const onExceptionSubmit = payload => {
				const encryptedPayload = {
			...payload,
			password: encryptStationPassword(payload.password)
		};
		raiseExceptionRequest(
			partValidation?.sequenceNumber,
			encryptedPayload,
			data => {
				setExceptionPopup(false);
				updatePartValidation({...partValidation, isExceptionRaised: true});
				redirectToNextScreen();
			},
			error => {
				setExceptionPopup(false);
				showMessageOverlay({
					contextText: ERROR_MESSAGE.ERROR_CONTEXT_TEXT + 'Raise exception',
					info: error?.response?.data?.message,
					error: true,
				});
				// logError(`Exception request failed ${error}`);
			},
		);
	};

	return (
		<>
			<LargeButton
				backgroundColor='#82C1A7'
				name='EXCEPTION'
				sx={{...btnStyles}}
				onClick={addAsException}
			/>
			{openException && (
				<ExceptionPopup
					open={openException}
					handleClose={() => setExceptionPopup(false)}
					handleSubmit={onExceptionSubmit}
				/>
			)}
		</>
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(Exception);
